import type { JSX } from 'react';
import { IconType } from '../../Atoms/Icon';
import { TextColors } from '../../Atoms/Text';
import { CardWithTitle } from '../CardWithTitle';

export interface DetailViewCardProps {
  title: string;
  titleColor?: keyof typeof TextColors;
  children: JSX.Element | JSX.Element[];
  childrenWrapperClass?: string;
  cardActions?: JSX.Element | JSX.Element[];
  enableCollapse?: boolean;
  className?: string;
  collapsed?: boolean;
  dataCy?: string;
  titleIcon?: IconType;
  dataTestId?: string;
  onCollapseClick?: (collapse: boolean) => void;
}

export function DetailViewCard({
  title,
  titleColor,
  children,
  childrenWrapperClass,
  cardActions,
  enableCollapse,
  className,
  collapsed = false,
  titleIcon,
  dataCy = '',
  dataTestId = '',
  onCollapseClick
}: DetailViewCardProps) {
  return (
    <CardWithTitle
      cardActions={cardActions}
      title={title}
      titleColor={titleColor}
      titleIcon={titleIcon}
      enableCollapse={enableCollapse}
      onCollapseClick={onCollapseClick}
      titlePadding="p-3"
      className={className}
      childrenWrapperClass={childrenWrapperClass}
      collapsed={collapsed}
      dataCy={dataCy}
      dataTestId={dataTestId}>
      {children}
    </CardWithTitle>
  );
}
